module.exports = __webpack_public_path__ + "img/sector0_doubles.b5eee651.svg";